import { registerPlugin } from '@capacitor/core';
const CapacitorPayment = registerPlugin('CapacitorPayment', {
    web: () => import('./web').then(m => new m.CapacitorPaymentWeb()),
});
export * from './definitions';
export { CapacitorPayment };
//# sourceMappingURL=index.js.map